import { Link } from 'react-router-dom'
import type { InvoiceRow, ReminderStepRow } from '../types'
import { formatCurrency, formatDate } from '../utils/helpers'
import StatusBadge from './StatusBadge'
import Card from './Card'

interface Props {
  invoice: InvoiceRow & { reminder_steps?: ReminderStepRow[] }
}

export default function InvoiceCard({ invoice }: Props) {
  const nextReminder = invoice.reminder_steps?.find((r) => r.status === 'scheduled')

  return (
    <Link to={`/invoices/${invoice.id}`}>
      <Card className="transition-colors hover:border-ica-accent/30">
        <div className="flex items-center justify-between">
          <h3 className="font-medium">{invoice.invoice_label}</h3>
          <StatusBadge status={invoice.status} />
        </div>
        <p className="mt-1 text-sm text-ica-text-muted">{invoice.client_name}</p>
        <div className="mt-4 flex items-center justify-between text-sm">
          <span className="font-semibold">{formatCurrency(invoice.invoice_amount, invoice.currency)}</span>
          <span className="text-ica-text-muted">Due {formatDate(invoice.due_date)}</span>
        </div>
        {nextReminder && (
          <p className="mt-3 text-xs text-ica-text-muted">
            Next reminder: {formatDate(nextReminder.scheduled_for)}
          </p>
        )}
      </Card>
    </Link>
  )
}
